module.exports = __webpack_public_path__ + "static/media/C2C.5544bd4f.png";